<template>
  <section class="article">
    <div class="container">
      <div class="row">
        <div class="col-12 head">
          <h2 class="title">{{ $t('navigation.how_it_works') }}</h2>
        </div>
      </div>
      <div class="row text-justify">
        <div class="col-12 pb-4">
          <p>{{ $t('how_it_works.description') }}</p>
        </div>
      </div>
      <div class="row">
        <div class="col-12 pb-4">
          {{ $t('how_it_works.download_files') }}
          <ul>
            <li>
              <a href="https://genomed.pl/images/stories/2022/deklaracja_swiadomej_zgody_na_badanie_calogenomowe_wgs_v3.1_-_30122021.pdf"
              target="_blank">
              {{ $t('how_it_works.file_1') }}
              </a>
            </li>
            <li>
              <a href="https://genomed.pl/images/stories/2022/pacjent_genomed_oswiadczenie_dane_osobowe.pdf"
              target="_blank">
              {{ $t('how_it_works.file_2') }}
              </a>
            </li>
          </ul>
        </div>
      </div>


    <!-- how it works -->
    <div class="how-it-works pt-4">
        <div class="row sin">
          <div class="col-lg col-md-12 col-sm-12 col1 col">
            <img src="../assets/img/hand-press-icon.png" alt="" class="img">
            <h5 class="description">{{$t('home.choose_your_option')}}</h5>
          </div>
          <div class="col-md col-con">
            <img src="../assets/img/sin-down.png" alt="" class="img">
          </div>
          <div id="sciezka1">
            <img src="../assets/img/sciezka1.png" alt="">
          </div>
          <div class="col-lg col-md-12 col-sm-12 col2 col">
            <h5 class="description_mobilna">
              {{$t('home.use_kit_and_send_sample')}}
            </h5>
            <img src="../assets/img/car-icon.png" alt="" class="img">
            <h5 class="description">
              {{$t('home.use_kit_and_send_sample')}}
            </h5>
          </div>
          <div class="col-lg col-con">
            <img src="../assets/img/sin-up.png" alt="" class="img">
          </div>
          <div id="sciezka2">
            <img src="../assets/img/sciezka2.png" alt="">
          </div>
          <div class="col-lg col-md-12 col-sm-12 col3 col">
            <img src="../assets/img/lab-icon.png" alt="" class="img">
            <h5 class="description">{{$t('home.our_lab_will_test_it')}}</h5>
          </div>
          <div class="col-lg col-con">
            <img src="../assets/img/sin-down.png" alt="" class="img">
          </div>
          <div id="sciezka3">
            <img src="../assets/img/sciezka3.png" alt="">
          </div>
          <div class="col-lg col-md-12 col-sm-12 col4 col">
            <h5 class="description_mobilna">{{$t('home.download_results')}}</h5>
            <img src="../assets/img/hand-num-icon.png" alt="" class="img">
            <h5 class="description">{{$t('home.download_results')}}</h5>
          </div>
          <div class="col-md col-con">
            <img src="../assets/img/sin-up.png" alt="" class="img">
          </div>
          <div id="sciezka4">
            <img src="../assets/img/sciezka4.png" alt="">
          </div>
          <div class="col-lg col-md-12 col-sm-12 col5 col">
            <img src="../assets/img/display-icon.png" alt="" class="img">
            <h5 class="description">
              {{$t('home.register_video_consultation')}}
            </h5>
          </div>
        </div>
    </div>



    </div>
  </section>
</template>

<script>
export default {
  name: "HowItWorks"
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/HowItWorks.vue